import { Box, TableBody, TableCell, TableRow } from '@material-ui/core'
import { Actions, Field } from './types'
import { useTranslation } from 'react-i18next'
import { makeStyles } from '@material-ui/core/styles'
import { GenericTooltip } from '../generic-tooltip'
import { selectClasses } from '@mui/material'

export type BodyProps<T> = {
  readonly fields: Field<T>[]
  readonly items: T[]
  readonly rowKeyField: keyof T
  readonly actions?: Actions<T>
  readonly includesCheck?: boolean
  readonly handleCheck?: (e: T) => void
  readonly clicked?: boolean
  readonly handleClicked?: ()=>void
  readonly selectedID?: string
}

export function Body<T extends { [key: string]: any }>(props: BodyProps<T>) {
  const { t } = useTranslation()

  const useStyles = makeStyles((_) => ({
    body: {
      fontSize: '14px',
      fontFamily: 'poppins',
      borderBottom: '1px solid #D1D1D1',
      padding: '0 auto 0 auto',
    },
    icon: {
      verticalAlign: 'middle',
      cursor: 'pointer',
      paddingTop: '0',
      paddingBottom: '0',
    },
  }))

  const handleClic = (item: any ) => {
    if (props.clicked){

      if (props.selectedID === item?.id && props.handleClicked ) props.handleClicked()
      else props.handleCheck && props.handleCheck(item)
    }
  }

  const classes = useStyles()

  const rows = props.items?.map((item) => (
    <TableRow key={item[props.rowKeyField]} >
       {props.includesCheck && (
          <TableCell onClick={() => handleClic(item)}>
            <input
              type="checkbox"
              checked={props.selectedID == item.id}
              onChange={() => props.handleCheck && props.handleCheck(item)}
          />
          </TableCell>
        )}
      {Object.values(props.fields)?.map((field) => (
        <TableCell key={field.name as string } onClick={() => handleClic(item)}>
          {field.renderFunc
            ? field.renderFunc(field, item)
            : item[field.name] && item[field.name].toString()}
        </TableCell>
      ))}

      {props.actions && props.actions.items?.length > 0 && (
        <TableCell key="actions-table">
          <Box display="flex" justifyContent="space-between">
            {props.actions.items.map((a) => {
              if (a.hidden && a.hidden(item)) {
                return <></>
              }
              return (
                <GenericTooltip
                  values={[t(a.label || a.icon)]}
                  icon={
                    <img
                      src={a.icon}
                      className={classes.icon}
                      key={item[props.rowKeyField]}
                      onClick={() => a.handler(item)}
                    />
                  }
                  noUseFab={true}
                />
              )
            })}
          </Box>
        </TableCell>
      )}
    </TableRow>
  ))

  return <TableBody>{rows}</TableBody>
}
